import { render, staticRenderFns } from "./split_button.vue?vue&type=template&id=bfc607b0&"
import script from "./split_button.vue?vue&type=script&lang=js&"
export * from "./split_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports